{
  "decrease": "Μείωση {fieldLabel}",
  "increase": "Αύξηση {fieldLabel}",
  "numberField": "Πεδίο αριθμού"
}
